<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <div class="flex items-center justify-between w-full gap-6">
      <div class="flex items-center gap-2">
        <span class="text-lg font-medium">
          {{ textTemplate()?.translations | translateDirectus }}
        </span>
      </div>
    </div>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <app-safe-html-output
    class="prose prose-sm max-w-none"
    [html]="textTemplate()?.translations | translateDirectusTemplate"
  />
</p-panel>
